import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useIsSuperAdmin } from '@/features/auth/hooks/useIsAdmin';
import { LoadingSpinner } from '@elka/ui';

interface SuperAdminRouteProps {
  children: ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { isLoading } = useAuth();
  const isSuperAdmin = useIsSuperAdmin();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/projects/clients" replace />;
  }

  return <>{children}</>;
}
